// extracted by mini-css-extract-plugin
export default {"text":"ReadMore_text__zTpiJ","read-or-hide":"ReadMore_read-or-hide__NjSjY"};